import localStorageService from "../services/LocalStorageService";

export const getHeaders = () => {
  const role = localStorageService.getItem("role") || "admin";

  return [
    {
      label: "Stores",
      link: "/home",
      icon: "fas fa-fw fa-tachometer-alt",
      show: role === "admin",
    },
    {
      label: "SKUs to GWP Mapping",
      link: "/mapping-management",
      icon: "fas fa-fw fa-tachometer-alt",
      show: role === "admin",
    },
    {
      label: "User Management",
      link: "/user-management",
      icon: "fas fa-fw fa-tachometer-alt",
      show: role === "admin",
    },
    {
      label: "Pullout Letter Names",
      link: "/pullout-letter-names",
      icon: "fas fa-fw fa-tachometer-alt",
      show: role === "admin",
    },
    {
      label: "Request Management",
      link: "/request-management",
      icon: "fas fa-fw fa-tachometer-alt",
      show: role !== "admin",
    },
    {
      label: "Replenishment Requests",
      link: "/replenishment-requests",
      icon: "fas fa-fw fa-tachometer-alt",
      show: role !== "admin",
    },
    {
      label: "Discounts",
      link: "/discounts",
      icon: "fas fa-fw fa-tachometer-alt",
      show: role === "admin" || role === "supervisor",
    },
    {
      label: "Bulk Upload",
      link: "/bulk-upload",
      icon: "fas fa-fw fa-tachometer-alt",
      show: role === "admin",
    },
    {
      label: "Promotions",
      link: "/promotions",
      icon: "fas fa-fw fa-tachometer-alt",
      show: role === "admin",
    },
    {
      label: "Reconciliation",
      link: "/reconciliation",
      icon: "fas fa-fw fa-tachometer-alt",
      show:
        role === "admin" &&
        (process.env.REACT_APP_FEATURE_RECONCILIATION
          ? process.env.REACT_APP_FEATURE_RECONCILIATION === "true"
          : true),
    },
    {
      label: "Replenishment",
      link: "/replenishment",
      show: role === "admin",
    },
    {
      label: "Logout",
      link: "/",
      icon: "fas fa-fw fa-tachometer-alt",
      show: true,
    },
  ];
};
